import { api } from '../lib/api'
import type { SettingItem } from '../lib/types'

export interface WindsorTestRequest {
  url: string
  connector: string
  fields: string[]
  datePreset: string
  accountIds: string[]
}

export interface WindsorTestResult {
  ok: boolean
  rowCount?: number
  sample?: unknown[]
  error?: string
  request?: WindsorTestRequest
}

export const settingsApi = {
  get: () => api.get<{ settings: SettingItem[] }>('/settings'),
  update: (data: Record<string, string>) =>
    api.put<{ ok: true; updated: string[] }>('/settings', data),
  testWindsor: (body: { connector?: string; accountIds?: string[] }) =>
    api.post<WindsorTestResult>('/settings/test-windsor', body),
}
